import { Action } from "@reduxjs/toolkit";
import Cookies from 'js-cookie';
import { Rootstate } from "../../store";


interface AuthState {
    isAuthenticated: boolean,
    channelId: string | undefined,
    guildId: string | undefined,
}


const defaultState: AuthState = {
    isAuthenticated: Cookies.get('access_token') !== undefined,
    channelId: undefined,
    guildId: undefined,
};


interface AuthAction extends Action {
  value: boolean
}

interface IdsAction extends Action {
    channelId: string,
    guildId: string
}

const zoomReducer = (state = defaultState, action: Action): typeof defaultState => {
    switch (action.type) {
    case 'AUTH/SET_AUTH': {
        const authAction = action as AuthAction;
        return {
            ...state,
            isAuthenticated: authAction.value,
        };
    }
    case 'AUTH/SET_IDS': {
        const idAction = action as IdsAction;
        return {
            ...state,
            channelId: idAction.channelId,
            guildId: idAction.guildId,
        };
    }
    default:
        return state;
    }
};

export const authSelector = (state: Rootstate) => state.auth;

export default zoomReducer;

